import { render, staticRenderFns } from "./MonitNbhd.vue?vue&type=template&id=ec2933de&scoped=true&"
import script from "./MonitNbhd.vue?vue&type=script&lang=js&"
export * from "./MonitNbhd.vue?vue&type=script&lang=js&"
import style0 from "./MonitNbhd.vue?vue&type=style&index=0&id=ec2933de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2933de",
  null
  
)

export default component.exports